export default class BillingCycles {
  static defaultValues = () => [ 1 ]
}
